<div class="content">
    <div class="step-header">
        <div class="title">Site subnets</div>
    </div>
    <div class="step-content md-margin-top">
        <subnet-settings
            [parentOutput]="step.output"
            [parent]="'subnets'"
            [step]="step"
            [key] = "'subnets'"
            [validateUrl] = "step.config.dataUrl">
        </subnet-settings>
    </div>
</div>
